module.exports = __webpack_public_path__ + "static/media/undraw_personal_opinions_g3kr.2c3054c1.svg";